import { supabase } from '../lib/supabase';

export const getSquads = async () => {
    const { data, error } = await supabase
        .from('squads')
        .select('id, nome, ativo, criado_em, foto_url, bd_pessoas(id, nome, cargo, squad_leader)')
        .order('nome');
    if (error) throw error;
    return data || [];
};

/**
 * Sobe a foto do squad pela rota server-side.
 *
 * Antes esta funcao trazia a `service_role` key literal e fazia PUT direto no storage com ela.
 * Como o arquivo e importado por `pages/Squads.jsx` e o desk e app client-side, a chave ia no
 * bundle servido ao navegador — credencial que ignora RLS, legivel por qualquer pessoa com acesso
 * ao app. Detectado pelo gitleaks em 2026-08-05.
 *
 * A operacao passou para `api/upload-squad-foto.js`, seguindo o padrao que o projeto ja usa para
 * o que exige service role (ver `api/criar-usuario.js`): a chave fica no servidor e o cliente so
 * manda o arquivo com o proprio token de sessao.
 */
export const uploadSquadFoto = async (squadId, file) => {
    if (file.size > 2 * 1024 * 1024) throw new Error('Arquivo deve ter menos de 2MB');
    if (!file.type.startsWith('image/')) throw new Error('Apenas imagens sao permitidas');

    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Sessao expirada. Entre novamente.');

    const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
    const res = await fetch(
        `/api/upload-squad-foto?squadId=${encodeURIComponent(squadId)}&ext=${encodeURIComponent(ext)}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${session.access_token}`,
                'Content-Type': file.type,
            },
            body: file,
        }
    );
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.error || `Upload falhou: ${res.status}`);

    return body.publicUrl;
};

export const criarSquad = async (nome) => {
    const { error } = await supabase
        .from('squads')
        .insert({ nome: nome.trim() });
    if (error) throw error;
};

export const desativarSquad = async (id) => {
    const { error } = await supabase
        .from('squads')
        .update({ ativo: false })
        .eq('id', id);
    if (error) throw error;
};

export const getPessoasSemSquad = async () => {
    const { data, error } = await supabase
        .from('bd_pessoas')
        .select('id, nome, cargo')
        .is('squad_id', null)
        .order('nome');
    if (error) throw error;
    return data || [];
};

export const adicionarMembro = async (pessoaId, squadId) => {
    const { error } = await supabase
        .from('bd_pessoas')
        .update({ squad_id: squadId })
        .eq('id', pessoaId);
    if (error) throw error;
};

export const removerMembro = async (pessoaId) => {
    const { error } = await supabase
        .from('bd_pessoas')
        .update({ squad_id: null, squad_leader: false })
        .eq('id', pessoaId);
    if (error) throw error;
};

export const setSquadLeader = async (squadId, pessoaId, setAsLeader) => {
    // Clear current leader in squad first
    const { error: e1 } = await supabase
        .from('bd_pessoas')
        .update({ squad_leader: false })
        .eq('squad_id', squadId);
    if (e1) throw e1;

    if (setAsLeader) {
        const { error: e2 } = await supabase
            .from('bd_pessoas')
            .update({ squad_leader: true })
            .eq('id', pessoaId);
        if (e2) throw e2;
    }
};
